var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewardsBoxed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_2057_98502)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.227848 23.5C0.100253 23.5 0 23.3992 0 23.2709V7.40138C0 3.60699 3.08962 0.5 6.86278 0.5H35.7722C35.8952 0.5 36 0.605399 36 0.729129V16.5986C36 20.393 32.9104 23.5 29.1418 23.5H0.227848Z",
    fill: "#FF6400"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.6165 6.05396H19.8778C18.333 6.05396 17.0844 7.305 17.0707 8.85392V6.5947C17.0707 6.28308 16.8383 6.05396 16.5558 6.05396H15.4165H14.2727C13.9902 6.05396 13.7578 6.28767 13.7578 6.5947V17.9733C13.7578 18.2574 13.9902 18.4911 14.2682 18.4911H15.412H16.5558C16.8383 18.4911 17.0662 18.2574 17.0707 17.9733V10.9298C17.0707 10.9115 17.0707 10.8932 17.0753 10.8794C17.1892 10.1095 17.5219 9.40383 18.055 8.85392C18.7887 8.09321 19.8095 7.67619 20.935 7.67619C21.0125 7.67619 21.0763 7.73576 21.0854 7.81367C21.09 7.89157 21.0353 7.96031 20.9578 7.97406C20.9441 7.97864 19.3993 8.21694 18.5153 9.4634C18.2191 9.88041 18.0277 10.3616 17.9457 10.9069H19.9735C21.5229 10.9069 22.7806 9.64212 22.7806 8.08404V6.22809C22.7806 6.12728 22.7077 6.05396 22.6165 6.05396Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2057_98502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 23,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsBoxed);
export default __webpack_public_path__ + "static/media/rewards-boxed.17a2d7664d8bd30585aec497c6ce50ef.svg";
export { ForwardRef as ReactComponent };